import Layout from '@/components/layout/Layout';

const Zasebnost = () => {
  return (
    <Layout
      title="Politika zasebnosti | Lux Decor by Kamen"
      description="Politika zasebnosti podjetja Lux Decor by Kamen z informacijami o tem, kako zbiramo, uporabljamo in varujemo vaše osebne podatke."
    >
      <section className="py-16 bg-luxbeige">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-semibold mb-6">Politika zasebnosti</h1>
            <div className="h-1 w-24 bg-luxgold mb-10"></div>
            
            <div className="lux-card space-y-6">
              <section>
                <h2 className="text-2xl font-medium mb-4">1. Splošno</h2>
                <p className="text-luxgray">
                  Podjetje KAMEN d.o.o. spoštuje vašo zasebnost in se zavezuje k varovanju vaših osebnih podatkov. Ta politika zasebnosti pojasnjuje, 
                  kako zbiramo, uporabljamo, razkrivamo, obdelujemo in varujemo vaše osebne podatke, ko obiskujete našo spletno stran ali kupujete naše izdelke.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">2. Vrste podatkov, ki jih zbiramo</h2>
                <p className="text-luxgray">
                  Med uporabo naše spletne strani lahko zbiramo naslednje vrste osebnih podatkov:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Kontaktni podatki: ime, priimek, e-poštni naslov, telefonska številka, naslov za dostavo</li>
                  <li>Podatki o transakcijah: podatki o izdelkih, ki ste jih kupili, datum nakupa, znesek plačila</li>
                  <li>Tehnični podatki: naslov IP, vrsta in verzija brskalnika, nastavitev časovnega pasu, vrste in verzije vtičnikov za brskalnik, operacijski sistem in platforma</li>
                  <li>Podatki o uporabi: informacije o tem, kako uporabljate našo spletno stran, izdelke in storitve</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">3. Kako uporabljamo vaše podatke</h2>
                <p className="text-luxgray">
                  Vaše osebne podatke uporabljamo za naslednje namene:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Za obdelavo in dostavo vaših naročil</li>
                  <li>Za komunikacijo z vami glede vaših naročil, izdelkov ali storitev</li>
                  <li>Za izboljšanje naše spletne strani, izdelkov in storitev</li>
                  <li>Za pošiljanje promocijskih sporočil, če ste se prijavili na naš newsletter</li>
                  <li>Za izpolnjevanje naših zakonskih obveznosti</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">4. Deljenje vaših podatkov</h2>
                <p className="text-luxgray">
                  Vaših osebnih podatkov ne bomo prodali, razkrili ali delili s tretjimi osebami, razen v primerih, opisanih v tej politiki zasebnosti.
                  Vaše podatke lahko delimo s:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Ponudniki storitev, ki nam pomagajo pri poslovanju (npr. dostavne službe, ponudniki plačilnih storitev)</li>
                  <li>Uradnimi organi, če to zahteva zakon</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">5. Varnost podatkov</h2>
                <p className="text-luxgray">
                  Izvajamo ustrezne tehnične in organizacijske ukrepe za zaščito vaših osebnih podatkov pred izgubo, zlorabo ali nepooblaščenim dostopom.
                  Vsi osebni podatki, ki nam jih posredujete, so shranjeni na varnih strežnikih.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">6. Hranjenje podatkov</h2>
                <p className="text-luxgray">
                  Vaše osebne podatke hranimo le toliko časa, kot je potrebno za namene, za katere smo jih zbrali, vključno z izpolnjevanjem zakonskih, 
                  računovodskih ali poročevalskih zahtev.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">7. Vaše pravice</h2>
                <p className="text-luxgray">
                  V skladu z veljavno zakonodajo o varstvu podatkov imate naslednje pravice:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Pravica do dostopa do svojih osebnih podatkov</li>
                  <li>Pravica do popravka netočnih osebnih podatkov</li>
                  <li>Pravica do izbrisa svojih osebnih podatkov</li>
                  <li>Pravica do omejitve obdelave svojih osebnih podatkov</li>
                  <li>Pravica do prenosljivosti podatkov</li>
                  <li>Pravica do ugovora proti obdelavi svojih osebnih podatkov</li>
                </ul>
                <p className="text-luxgray mt-2">
                  Za uveljavljanje katerekoli od teh pravic nas kontaktirajte na info@luxdecor.si.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">8. Spremembe politike zasebnosti</h2>
                <p className="text-luxgray">
                  To politiko zasebnosti lahko občasno posodobimo. Vse spremembe bodo objavljene na tej strani z navedbo datuma zadnje posodobitve.
                </p>
                <p className="text-luxgray mt-2">
                  Ta politika zasebnosti je bila nazadnje posodobljena 1.1.2023.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">9. Kontakt</h2>
                <p className="text-luxgray">
                  Če imate kakršnakoli vprašanja o tej politiki zasebnosti ali o tem, kako obdelujemo vaše osebne podatke, 
                  nas kontaktirajte na info@luxdecor.si ali +386 31 467 272.
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Zasebnost;